import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c === 0 ? total - 1 : c - 1));
  const next = () => setCurrent((c) => (c === total - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            ( What Buyers Say )
          </h2>

          <div className="flex items-center justify-center gap-2 mb-8 mt-4">
            <div className="inline-flex items-center gap-1.5 bg-foreground-900 text-background-50 rounded-full px-4 py-1.5">
              <i className="ri-star-fill text-accent-400 text-sm"></i>
              <span className="text-sm font-semibold">{t.rating}</span>
            </div>
          </div>

          <blockquote className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed italic mb-8 px-4">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          <div className="flex items-center justify-center gap-3">
            <div className="w-10 h-10 rounded-full bg-secondary-200 overflow-hidden flex items-center justify-center">
              <i className="ri-user-line text-foreground-500"></i>
            </div>
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.handle}</p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-10">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-200 text-foreground-500 hover:bg-foreground-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}